import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, CardContent, Link, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { hasHyperUser } from '../../helpers/access';
import { RelativeLoadingAnimation } from '../../Popup/Loading';
import { NavSections } from '../navigation/NavSections';
import { DeviceLinkContext } from './DeviceLinkContext';
import { checkHierarchy } from './Support/LinkingSupportFunctions';
const DeviceRelations = (props) => {
    const { relations, setAllowEntities } = props;
    const { device, allowEntities, entityOptions } = useContext(DeviceLinkContext);
    const [{ contextUser, contextCustomer, userGroupRoles }] = useContext(AppMainViewContext);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const hasHyper = hasHyperUser(userGroupRoles);
    const supportEmail = config.app.webUI.supportEmail;
    const navigate = useNavigate();
    const isDeviceLinked = (mapper, options) => {
        if (mapper === undefined) {
            return false;
        }
        const relations = mapper.getContainedItems();
        const types = options.map((val) => val.name);
        const found = relations.some((val) => types.includes(val.type));
        return found;
    };
    useEffect(() => {
        if (device && contextCustomer && contextUser && relations) {
            const timer = setTimeout(() => {
                setLoading(true);
                //&& entityOptions
                checkHierarchy(device, contextUser, contextCustomer).then((messageRes) => {
                    setMessage(messageRes);
                    const res = isDeviceLinked(relations, entityOptions);
                    const messageError = messageRes !== undefined; // && !!!message.includes('already assigned');
                    setAllowEntities(!res && !messageError);
                    setLoading(false);
                });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        }
        else {
            setLoading(false);
        }
    }, [device, contextUser, contextCustomer, relations]); //, entityOptions
    return (_jsx("div", { style: { minWidth: '100%', maxWidth: '480px' }, children: loading ? (_jsx(RelativeLoadingAnimation, {})) : (_jsx(Box, { sx: { border: 1, borderColor: allowEntities ? 'black' : 'red', borderRadius: '10px' }, children: _jsx(CardContent, { children: device === undefined ? (_jsxs("div", { children: [_jsx(Typography, { variant: "subtitle2", component: "h6", color: "primary", children: "No Valid Device Found" }), _jsx("br", {}), _jsx(Button, { fullWidth: true, variant: "contained", onClick: () => {
                                navigate(`/${NavSections.ADMIN_VIEW}/Group?supportedType=Device`);
                            }, children: "Create New Device" })] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "subtitle1", component: "h6", color: "primary", children: _jsx("b", { children: allowEntities ? 'Allowed Device Link' : 'Device Not Allowed' }) }), hasHyper &&
                            relations?.getContainedItems().map((val) => {
                                let header = val.type;
                                if (val.supportedType) {
                                    header += ` (${val.supportedType})`;
                                }
                                return (_jsxs(_Fragment, { children: [message && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body2", component: "p", color: "primary", children: message }), _jsx("br", {})] })), _jsxs(Typography, { variant: "body2", component: "p", color: "primary", children: [header, ":", ' ', _jsx(Link, { href: `/${NavSections.THINGVIEW}/${val.type}/${val.id}`, target: "_blank", rel: "noopener", children: val.name })] })] }));
                            }), !allowEntities ? (supportEmail !== undefined ? (_jsxs(_Fragment, { children: ["Please contact ", _jsx("a", { href: `mailto:${supportEmail}`, children: supportEmail }), " or your reseller"] })) : (_jsx(_Fragment, { children: "No Support Email Provided" }))) : (_jsx(_Fragment, {}))] })) }) })) }));
};
export default DeviceRelations;
